import XLSX from "xlsx";

const list = {
  hideCreateButton() {
    return true;
  },
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "대상년도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-start-end",
        label: "작업기간",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { addList: ["업체명", "공사명", "공사금액"], hiddenList: ["대상년도", "작성일", "구분1", "서류평가(40)", "현장평가(60)", "총점(100)"] },
      },
      {
        component: "search-select",
        label: "상태",
        value: "상태",
        query: { s1: "select" },
        options: {
          default: "전체",
          items: ["전체", "현장평가 필요", "현장평가 필요(기한초과)", "적합", "안전환경위원회 심의 필요"],
          immediate: true,
        },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // parentsPostId 845 팝업 LIST 전용
    if (nav.parentsPostId) {
      const parentsPostId = nav.parentsPostId;
      conditions.push({ key: "parentsPostId", operator: "=", value: `${parentsPostId}` });
    }

    // 검색연도 (작업기간 시작일자의 년도로 검색)
    const year = search.year;
    conditions.push({ key: "body.구분.작업기간.sDate", operator: "LIKE", value: `${year}%` });

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색일
    if (search.date) {
      conditions.push({ key: "body.구분.작업기간.sDate", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "body.구분.작업기간.eDate", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    // 상태
    if (search.상태 && search.상태 !== "전체") {
      switch (search.상태) {
        case "현장평가 필요":
          conditions.push({ key: "body.evaluationList[1].childs[0].value", operator: "=", value: 0 });
          conditions.push({ key: "body.evaluationList[1].childs[1].value", operator: "=", value: 0 });
          conditions.push({ key: "body.evaluationList[1].childs[2].value", operator: "=", value: 0 });
          conditions.push({ key: "body.evaluationList[1].childs[3].value", operator: "=", value: 0 });
          conditions.push({ key: "body.evaluationList[1].childs[4].value", operator: "=", value: 0 });
          conditions.push({ key: "body.evaluationList[1].childs[5].value", operator: "=", value: 0 });
          conditions.push({ key: "body.evaluationList[1].childs[6].value", operator: "=", value: 0 });
          conditions.push({ key: "body.구분.작업기간.eDate", operator: ">", value: new Date().format("yyyy-MM-dd") });
          break;
        case "현장평가 필요(기한초과)":
          conditions.push({ key: "body.evaluationList[1].childs[0].value", operator: "=", value: 0 });
          conditions.push({ key: "body.evaluationList[1].childs[1].value", operator: "=", value: 0 });
          conditions.push({ key: "body.evaluationList[1].childs[2].value", operator: "=", value: 0 });
          conditions.push({ key: "body.evaluationList[1].childs[3].value", operator: "=", value: 0 });
          conditions.push({ key: "body.evaluationList[1].childs[4].value", operator: "=", value: 0 });
          conditions.push({ key: "body.evaluationList[1].childs[5].value", operator: "=", value: 0 });
          conditions.push({ key: "body.evaluationList[1].childs[6].value", operator: "=", value: 0 });
          conditions.push({ key: "body.구분.작업기간.eDate", operator: "<=", value: new Date().format("yyyy-MM-dd") });
          break;
        case "적합":
          conditions.push({ key: "body.evaluationList[1].childs[%].value", operator: ">", value: 0 });
          conditions.push({ key: "body.userScore", operator: ">=", value: 70 });
          break;
        case "안전환경위원회 심의 필요":
          conditions.push({ key: "body.evaluationList[1].childs[%].value", operator: ">", value: 0 });
          conditions.push({ key: "body.userScore", operator: "<", value: 70 });
          break;
      }
    }

    //  검색조건
    const types = {};

    for (const item of list.getHead()) {
      const itemName = item.name.replace(/<br\/>/g, "");
      types[itemName] = item.key || null;
      if (item.child) {
        for (const child of item.child) {
          const childName = child.name.replace(/<br\/>/g, "");
          types[childName] = child.key || null;
        }
      }
    }

    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "대상년도",
        key: "body.구분.작업기간.sDate",
        style: { width: "74px" },
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
        style: { width: "84px" },
      },
      {
        name: "구분1",
        style: { width: "430px" },
        child: [
          {
            name: "업체명",
            key: "body.업체명.com_name",
            style: { width: "91px" },
          },
          {
            name: "공사명",
            key: "body.구분.공사명",
            style: { width: "97px" },
          },
          {
            name: "작업기간",
            key: "body.안전작업허가서정보.작업기간",
            style: { width: "120px" },
          },
          {
            name: "공사금액",
            key: "body.구분.공사금액",
            style: { width: "122px" },
          },
        ],
      },
      {
        name: "서류평가(40)",
        style: { width: "334px" },
        child: [
          {
            name: "리더십<br/>(10)",
            key: "body.evaluationList.0.childs.0",
            style: { width: "50px" },
          },
          {
            name: "근로자<br/>참여(10)",
            key: "body.evaluationList.0.childs.1",
            style: { width: "72px" },
          },
          {
            name: "위험요인 파악 및<br/>제거·대체·통제(10)",
            key: "body.evaluationList.0.childs.2",
            style: { width: "140px" },
          },
          {
            name: "비상조치<br/>계획(10)",
            key: "body.evaluationList.0.childs.3",
            style: { width: "72px" },
          },
        ],
      },
      {
        name: "현장평가(60)",
        style: { width: "600px" },
        child: [
          {
            name: "복장 및<br/>보호구(5)",
            key: "body.evaluationList.1.childs.0",
          },
          {
            name: "위험기계<br/>기구 상태(10)",
            key: "body.evaluationList.1.childs.1",
            style: { width: "102px" },
          },
          {
            name: "화재예방,<br/>표지판 설치(10)",
            key: "body.evaluationList.1.childs.2",
            style: { width: "116px" },
          },
          {
            name: "안전관리<br/>제도(10)",
            key: "body.evaluationList.1.childs.3",
          },
          {
            name: "안전미팅<br/>(5)",
            key: "body.evaluationList.1.childs.4",
          },
          {
            name: "환경관리<br/>(5)",
            key: "body.evaluationList.1.childs.5",
          },
          {
            name: "기초질서 등<br/>(15)",
            key: "body.evaluationList.1.childs.6",
            style: { width: "88px" },
          },
        ],
      },
      {
        name: "총점(100)",
        key: "body.userScore",
        style: { width: "80px" },
      },
      {
        name: "비고",
        style: { width: "194px" },
        key: "body.subInfo.비고",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      switch (index) {
        case 0: {
          // 대상연도 (작업기간 시작일자의 년도)
          const content0 = func.getContent(value);
          const sDate0 = content0.구분 && content0.구분.작업기간 ? content0.구분.작업기간.sDate || "" : "";
          return sDate0 ? sDate0.substring(0, 4) : "";
        }
        case 1:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 2:
          // 작업기간 안전 처리
          let 작업기간 = "";
          const content = func.getContent(value);
          if (content.구분 && content.구분.작업기간) {
            const sDate = content.구분.작업기간.sDate || "";
            const eDate = content.구분.작업기간.eDate || "";
            if (sDate && eDate) {
              작업기간 = `${sDate}~\n${eDate}`;
            } else if (sDate) {
              작업기간 = sDate;
            } else if (eDate) {
              작업기간 = eDate;
            }
          }
          const 공사금액 = func.comma(func.getContent(value).구분.공사금액 ? func.getContent(value).구분.공사금액 : "");
          return {
            type: "child",
            datas: [
              func.getContent(value).업체명.com_name, // 업체명
              func.getContent(value).구분.공사명, // 공사명
              작업기간,
              공사금액,
            ],
          };

        case 3:
          // 서류평가(40)
          return {
            type: "child",
            datas: [
              func.getContent(value).evaluationList[0].childs[0].value,
              func.getContent(value).evaluationList[0].childs[1].value,
              func.getContent(value).evaluationList[0].childs[2].value,
              func.getContent(value).evaluationList[0].childs[3].value,
            ],
          };
        case 4:
          // 현장평가(60)
          return {
            type: "child",
            datas: [
              func.getContent(value).evaluationList[1].childs[0].value,
              func.getContent(value).evaluationList[1].childs[1].value,
              func.getContent(value).evaluationList[1].childs[2].value,
              func.getContent(value).evaluationList[1].childs[3].value,
              func.getContent(value).evaluationList[1].childs[4].value,
              func.getContent(value).evaluationList[1].childs[5].value,
              func.getContent(value).evaluationList[1].childs[6].value,
            ],
          };
        case 5:
          return func.getContent(value).userScore;
        case 6:
          // 현장평가 여부 체크
          const hasFieldEvaluation = func.getContent(value).evaluationList[1].childs.some(function (child) {
            return child.value > 0;
          });

          // 현장평가를 하지 않은 경우 (최우선)
          if (!hasFieldEvaluation) {
            const currentDate = new Date();
            let workEndDate;
            const content = func.getContent(value);

            // eDate 안전 처리
            if (content.구분 && content.구분.작업기간 && content.구분.작업기간.eDate) {
              workEndDate = new Date(content.구분.작업기간.eDate);
            } else {
              // eDate가 없으면 완전한 미래로 가정 (기한초과가 아님)
              workEndDate = new Date("2099-12-31");
            }

            const isOverdue = currentDate > workEndDate;

            return {
              type: "colorBox",
              color: "#FF9F43",
              text: isOverdue ? "현장평가 필요(기한초과)" : "현장평가 필요",
            };
          }

          // 총점이 70점 미만인 경우
          if (func.getContent(value).userScore < 70) {
            return { type: "colorBox", color: "#EA5455", text: "안전환경위원회 심의 필요" };
          }

          // 정상적인 경우
          return { type: "colorBox", color: "#28C76F", text: "적합" };
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (/*nav*/) => {},
  getSearchKeyword: (/*nav*/) => {},
  getRowStyle: (value) => {
    const content = JSON.parse(value.post_content);

    // evaluationList[1] (현장평가)의 childs 배열에서 value가 0보다 큰 값이 있는지 확인
    if (content && content.body && content.body.evaluationList && content.body.evaluationList[1] && content.body.evaluationList[1].childs) {
      const hasFieldEvaluation = content.body.evaluationList[1].childs.some(function (child) {
        return child.value > 0;
      });

      // 현장평가를 하지 않은 경우
      if (!hasFieldEvaluation) {
        // 작업기간 초과 여부 확인
        const currentDate = new Date();
        let workEndDate;

        // eDate 안전 처리
        if (content.body.구분 && content.body.구분.작업기간 && content.body.구분.작업기간.eDate) {
          workEndDate = new Date(content.body.구분.작업기간.eDate);
        } else {
          // eDate가 없으면 완전한 미래로 가정 (기한초과가 아님)
          workEndDate = new Date("2099-12-31");
        }

        const isOverdue = currentDate > workEndDate;

        if (isOverdue) {
          return {
            backgroundColor: "#fff2e6", // 옅은 주황색 음영
          };
        }

        return {}; // 기한 내 현장평가 필요는 음영 없음
      }

      // 현장평가를 했고 총점이 70점 미만인 경우 붉은색 음영
      if (content.body.userScore < 70) {
        return {
          backgroundColor: "#ffe6e6", // 연한 붉은색
        };
      }

      // 현장평가를 했고 총점이 70점 이상인 경우 초록색 음영
      return {
        backgroundColor: "#d4f4dd", // 초록색 음영
      };
    }

    return {};
  },
  getInfoHTML: () => {
    return {
      title: "사외 수급업체 평가 기준",
      html: `
    <div>
    <span class="text-white" style="font-size: 14px; font-weight: 500; text-align: center; padding: 2px 7px; border-radius: 4px; background: rgb(234, 84, 85); margin-right:10px;">
              안전환경위원회 심의 필요
            </span>
            총점 70점 미만 시</div>
    `,
    };
  },
  customExcelDownload: (data, fileName, allList = []) => {
    // 새로운 워크북 생성
    const wb = XLSX.utils.book_new();

    // 헤더 구성
    const header1 = ["No.", "대상년도", "사업장명", "구분1", "", "", "", "서류평가(40)", "", "", "", "현장평가(60)", "", "", "", "", "", "", "총점(100)", "비고"];

    const header2 = [
      "",
      "",
      "",
      "업체명",
      "공사명",
      "작업기간",
      "공사금액",
      "리더십(10)",
      "근로자참여(10)",
      "위험요인파악(10)",
      "비상조치계획(10)",
      "복장보호구(5)",
      "위험기계기구(10)",
      "화재예방표지판(10)",
      "안전관리(10)",
      "안전미팅(5)",
      "환경관리(5)",
      "기초질서(15)",
      "",
      "",
    ];

    // 엑셀 데이터 생성
    const ws_data = [header1, header2];

    // 데이터 행 추가 (allList가 있으면 allList 사용, 없으면 data 사용)
    const dataToProcess = allList && allList.length > 0 ? allList : data;

    dataToProcess.forEach((_d, index) => {
      try {
        // post_content가 있는 경우 (allList 데이터) 파싱
        let postContent = null;
        if (_d.post_content) {
          postContent = JSON.parse(_d.post_content);
        }

        // 비고 계산 함수 (getCol의 case 6 로직)
        const calculateRemark = (content) => {
          if (!content || !content.body) return "";

          // 현장평가 여부 체크 (안전하게)
          let hasFieldEvaluation = false;
          if (content.body.evaluationList && content.body.evaluationList[1] && content.body.evaluationList[1].childs) {
            hasFieldEvaluation = content.body.evaluationList[1].childs.some((child) => child.value > 0);
          }

          // 현장평가를 하지 않은 경우 (최우선)
          if (!hasFieldEvaluation) {
            const currentDate = new Date();

            // eDate 안전 처리
            let workEndDate;
            if (content.body.구분 && content.body.구분.작업기간 && content.body.구분.작업기간.eDate) {
              workEndDate = new Date(content.body.구분.작업기간.eDate);
            } else {
              // eDate가 없으면 완전한 미래로 가정 (기한초과가 아님)
              workEndDate = new Date("2099-12-31");
            }

            const isOverdue = currentDate > workEndDate;
            return isOverdue ? "현장평가 필요(기한초과)" : "현장평가 필요";
          }

          // 총점이 70점 미만인 경우
          const userScore = content.body.userScore || 0;
          if (userScore < 70) {
            return "안전환경위원회 심의 필요";
          }

          // 정상적인 경우
          return "적합";
        };

        // 작업기간 포맷 함수
        const formatWorkPeriod = (startDate, endDate) => {
          if (!startDate && !endDate) return "";
          if (!startDate) return endDate; // sDate가 없으면 eDate만
          if (!endDate) return startDate; // eDate가 없으면 sDate만
          return `${startDate}~\n${endDate}`;
        };

        // 작업기간 안전 추출 함수
        const getWorkPeriod = (content) => {
          if (!content || !content.body || !content.body.구분 || !content.body.구분.작업기간) {
            return { sDate: "", eDate: "" };
          }
          return {
            sDate: content.body.구분.작업기간.sDate || "",
            eDate: content.body.구분.작업기간.eDate || "",
          };
        };

        // 평가 점수 안전 추출 함수
        const getEvaluationScore = (content, listIndex, childIndex) => {
          if (!content || !content.body || !content.body.evaluationList || !content.body.evaluationList[listIndex] || !content.body.evaluationList[listIndex].childs || !content.body.evaluationList[listIndex].childs[childIndex]) {
            return 0;
          }
          return content.body.evaluationList[listIndex].childs[childIndex].value || 0;
        };

        // 금액 포맷 함수
        const formatAmount = (amount) => {
          if (!amount) return "";
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        };

        // 작업기간 안전 추출
        const workPeriod = postContent ? getWorkPeriod(postContent) : { sDate: "", eDate: "" };

        const row = [
          index + 1, // No.
          postContent ? (workPeriod.sDate ? workPeriod.sDate.substring(0, 4) : "") : _d.대상년도 || "", // 대상년도 (작업기간 시작일자의 년도)
          postContent ? postContent.body.stdInfo.field_name : _d.사업장명 || "", // 사업장명

          // 구분1 (업체명, 공사명, 작업기간, 공사금액)
          postContent ? (postContent.body.업체명 ? postContent.body.업체명.com_name : "") : (_d.구분1 && _d.구분1.datas && _d.구분1.datas[0]) || "", // 업체명
          postContent ? (postContent.body.구분 ? postContent.body.구분.공사명 : "") : (_d.구분1 && _d.구분1.datas && _d.구분1.datas[1]) || "", // 공사명
          postContent ? formatWorkPeriod(workPeriod.sDate, workPeriod.eDate) : (_d.구분1 && _d.구분1.datas && _d.구분1.datas[2]) || "", // 작업기간
          postContent ? (postContent.body.구분 ? formatAmount(postContent.body.구분.공사금액) : "") : (_d.구분1 && _d.구분1.datas && _d.구분1.datas[3]) || "", // 공사금액

          // 서류평가(40) - 4개 항목
          postContent ? getEvaluationScore(postContent, 0, 0) : (_d["서류평가(40)"] && _d["서류평가(40)"].datas && _d["서류평가(40)"].datas[0]) || 0, // 리더십
          postContent ? getEvaluationScore(postContent, 0, 1) : (_d["서류평가(40)"] && _d["서류평가(40)"].datas && _d["서류평가(40)"].datas[1]) || 0, // 근로자참여
          postContent ? getEvaluationScore(postContent, 0, 2) : (_d["서류평가(40)"] && _d["서류평가(40)"].datas && _d["서류평가(40)"].datas[2]) || 0, // 위험요인파악
          postContent ? getEvaluationScore(postContent, 0, 3) : (_d["서류평가(40)"] && _d["서류평가(40)"].datas && _d["서류평가(40)"].datas[3]) || 0, // 비상조치계획

          // 현장평가(60) - 7개 항목
          postContent ? getEvaluationScore(postContent, 1, 0) : (_d["현장평가(60)"] && _d["현장평가(60)"].datas && _d["현장평가(60)"].datas[0]) || 0, // 복장보호구
          postContent ? getEvaluationScore(postContent, 1, 1) : (_d["현장평가(60)"] && _d["현장평가(60)"].datas && _d["현장평가(60)"].datas[1]) || 0, // 위험기계기구
          postContent ? getEvaluationScore(postContent, 1, 2) : (_d["현장평가(60)"] && _d["현장평가(60)"].datas && _d["현장평가(60)"].datas[2]) || 0, // 화재예방표지판
          postContent ? getEvaluationScore(postContent, 1, 3) : (_d["현장평가(60)"] && _d["현장평가(60)"].datas && _d["현장평가(60)"].datas[3]) || 0, // 안전관리
          postContent ? getEvaluationScore(postContent, 1, 4) : (_d["현장평가(60)"] && _d["현장평가(60)"].datas && _d["현장평가(60)"].datas[4]) || 0, // 안전미팅
          postContent ? getEvaluationScore(postContent, 1, 5) : (_d["현장평가(60)"] && _d["현장평가(60)"].datas && _d["현장평가(60)"].datas[5]) || 0, // 환경관리
          postContent ? getEvaluationScore(postContent, 1, 6) : (_d["현장평가(60)"] && _d["현장평가(60)"].datas && _d["현장평가(60)"].datas[6]) || 0, // 기초질서

          postContent ? postContent.body.userScore || 0 : _d["총점(100)"] || 0, // 총점
          postContent ? calculateRemark(postContent) : (_d.비고 && _d.비고.text) || "", // 비고
        ];
        ws_data.push(row);
      } catch (e) {
        console.error("엑셀 데이터 처리 중 오류:", e);
        // 오류가 발생한 경우 빈 행 추가
        ws_data.push([index + 1, "", "", "", "", "", "", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, ""]);
      }
    });

    // 워크시트 데이터 추가
    const ws = XLSX.utils.aoa_to_sheet(ws_data);

    // 병합 설정
    ws["!merges"] = [
      // 세로 병합 (2행에 걸쳐 병합)
      { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, // No. (A1:A2)
      { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }, // 대상년도 (B1:B2)
      { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } }, // 사업장명 (C1:C2)
      { s: { r: 0, c: 18 }, e: { r: 1, c: 18 } }, // 총점(100) (S1:S2)
      { s: { r: 0, c: 19 }, e: { r: 1, c: 19 } }, // 비고 (T1:T2)

      // 가로 병합 (첫 번째 행에서 병합)
      { s: { r: 0, c: 3 }, e: { r: 0, c: 6 } }, // 구분1 (D1:G1)
      { s: { r: 0, c: 7 }, e: { r: 0, c: 10 } }, // 서류평가(40) (H1:K1)
      { s: { r: 0, c: 11 }, e: { r: 0, c: 17 } }, // 현장평가(60) (L1:R1)
    ];

    // 워크북에 워크시트 추가
    XLSX.utils.book_append_sheet(wb, ws, "수급업체 안전보건수준평가");

    // 엑셀 파일 다운로드
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  },
};

export default list;
